import { DataTableFilterInjectContextProvider } from '~/shared/data-tables/query/DataTableFilterInjectContext';
import { PlanOfCareReviewTable } from './PlanOfCareReviewTable';
import { KpiCard } from '~/shared/components/KpiCard';
import { QueryDataTableFilterBar } from '~/shared/data-tables/query/QueryDataTableFilterBar';
import { FilterBar } from '~/shared/components/filter-bar/FilterBar';
import { PhysicianQueryDataFilter } from '~/libraries/physicians/filters/PhysicianQueryDataFilter';

export function PlanOfCareReviews() {
	return (
		<div className="space-y-6 p-8">
			<div className="grid grid-cols-1 gap-4 md:grid-cols-4">
				<KpiCard label="In Progress" value="0" subLabel="Total reviews in progress" />
				<KpiCard label="Overdue Reviews" value="9" subLabel="Reviews past due date" />
				<KpiCard label="Returned Reviews" value="2" subLabel="Reviews returned for rework" />
				<KpiCard label="Avg Review Length" value="11" subLabel="Avg time in days to complete review" />
			</div>
			<DataTableFilterInjectContextProvider>
				<QueryDataTableFilterBar>
					<FilterBar.Item label="Physician">
						<PhysicianQueryDataFilter fieldName="primaryPatientPhysicianId" />
					</FilterBar.Item>
				</QueryDataTableFilterBar>
				<PlanOfCareReviewTable />
			</DataTableFilterInjectContextProvider>
		</div>
	);
}
